import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TemplateRouteContext } from 'app/shared/model/template-route-context.model';

import { FORMS_ROUTES } from './forms-routes';
import { EmbedLibraryAppsComponent } from './templates-library/forms/embed-library-apps.component';
import { TemplatesModule } from './templates.module';

const routes: Routes = [
  {
    path: '',
    component: EmbedLibraryAppsComponent,
    children: [
      {
        path: 'library-apps/:templateId',
        data: {
          context: TemplateRouteContext.Library,
        },
        children: FORMS_ROUTES,
      },
    ],
  },
];

@NgModule({
  imports: [TemplatesModule, RouterModule.forChild(routes)],
})
export class EmbeddedTemplatesRoutedModule {}
